export const ABSOLUTE_PAGE_URL = {
  pdp: 'pdp',
  categorySearch: 'categorySearch',
  internalCms: 'internalCms',
} as const;

export type AbsoluteUrlPage = typeof ABSOLUTE_PAGE_URL[keyof typeof ABSOLUTE_PAGE_URL];
